import React, { FC } from "react";

import { TreaterPage } from "./Pages/TreaterPage";
import { InsuranceFiltersContext } from "./Utils/Context/filtersContext";
import { InsuranceLabelsContext } from "./Utils/Context/labelsContext";
import { InsuranceTreaterParams } from "../../Pages/InsuranceTreater/InsuranceTreaterParams.csharp";

export const InsuranceTreater: FC<InsuranceTreaterParams> = (props) => {
  return (
    <InsuranceLabelsContext labels={props.insuranceLabels}>
      <InsuranceFiltersContext>
        <TreaterPage {...props} />
      </InsuranceFiltersContext>
    </InsuranceLabelsContext>
  );
};
